import { useState, useEffect, useCallback } from 'react'

type Route = 'home' | 'products' | 'try-on' | 'customize'

export function useSimpleRouter() {
  const [currentRoute, setCurrentRoute] = useState<Route>(() => {
    const hash = window.location.hash.slice(1)
    if (hash === 'try-on') return 'try-on'
    if (hash === 'products') return 'products'
    if (hash === 'customize') return 'customize'
    return 'home'
  })

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1)
      if (hash === 'try-on') setCurrentRoute('try-on')
      else if (hash === 'products') setCurrentRoute('products')
      else if (hash === 'customize') setCurrentRoute('customize')
      else setCurrentRoute('home')
    }

    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [])

  const navigate = useCallback((route: Route) => {
    window.location.hash = route === 'home' ? '' : route
    setCurrentRoute(route)
  }, [])

  return { currentRoute, navigate }
}
